import { ITeamActionCreator, ITeamListState, ITeamActionTypes } from "models/ILeaveState";

const initialState: ITeamListState = {
  data: [],
};

const reducer = (state = initialState, { type, payload }: ITeamActionCreator) => {
  switch (type) {
    case ITeamActionTypes.FETCH_TEAM_LIST_FAILURE:
      return {
        ...state,
        data: [],
      };
    case ITeamActionTypes.FETCH_TEAM_LIST_SUCCESS:
      return {
        ...state,
        ...payload,
      };
    default:
      return state;
  }
};

export default reducer;
